<div class="loader-container" *ngIf="showLoader">
  <div class=" loader"></div>
</div>

<jqxLoader #loader [imagePosition]="'top'" [width]="100" [height]="60" [text]="translate('Procesando')">
</jqxLoader>

<jqxWindow #window jqxWindowAutoResize [theme]="tema" [zIndex]="900"
  [autoOpen]="true" [showCloseButton]="true" [showCollapseButton]="true"
  [resizable]="true" (onClose)="onClose()">
  <div class="formHeader" style="overflow-x: hidden;">
    LOPD
  </div>

  <div class="form" style="float:left; overflow: hidden;">
    <app-header #header [exportar]="true" [buscador]="true" [activeAppFilter]="true"
      [lopdCiudadanos]="true" [tablalopdfilter]="true" (eventFilter)="onFilter($event)" [filtro]="true"
      [resetFiltro]="true" (eventExportar)="onExportar()"
      (eventBuscador)="onBuscar($event)" (eventResetFilter)="eventResetFilter()" (eventCheckRol)="onSelectRol($event)"
      (eventCheckApps)="onCheckApps($event)" (eventCheckTabla)="onCheckTabla($event)">
    </app-header>

    <jqxTabs #tabs [theme]="tema" [width]="'100%'" [height]="'calc(100% - 66px)'" (onTabclick)="onTabClick($event)"
      [animationType]="'none'">
      <ul>
        <li>...</li>
        <li>...</li>
      </ul>
      <div class="overflow-hidden">
        <mcg-grid class="full-height"
          #myGrid [data]="dataAdapter" [columns]="columns" [configuration]="gridGeneralConfig">
        </mcg-grid>
      </div>
      <div class="overflow-hidden">
        <mcg-grid class="full-height"
          #myGridConf [data]="dataAdapterConf" [columns]="columnsConf" [configuration]="gridSettingsConfig"
          (onRowselect)="onChecked($event)" (onRowunselect)="onUnChecked($event)">
      </mcg-grid>
      </div>
    </jqxTabs>

    <div style="display: flex;">
      <jqxButton style="float:left" [width]='100' [height]='26' [textImageRelation]='"imageBeforeText"'
        [textPosition]='"left"' [imgPosition]="'left'" [imgSrc]='"/assets/images/save.png"'
        [value]="translate('Guardar')" (onClick)="onGuardar()" [disabled]="esDesactivado">
      </jqxButton>

      <jqxButton style="float: left; margin-left: 3px" [width]="100" [height]="26" [hidden]="!showCopy"
        [textImageRelation]="'imageBeforeText'" [textPosition]="'left'" [imgSrc]="'/assets/images/copy.png'"
        [imgPosition]="'left'" [value]="'Copiar Rol'" (onClick)="onClickCopyConfRol($event)">
      </jqxButton>

      <jqxButton style="float: left; margin-left: 3px" [width]="100" [height]="26"
        [textImageRelation]="'imageBeforeText'" [textPosition]="'left'" [imgSrc]="'/assets/images/cancel.png'"
        [imgPosition]="'left'" [value]="translate('CANCELAR')" (onClick)="componentRef.destroy()">
      </jqxButton>
    </div>
  </div>
</jqxWindow>
